<div class="flex-row gap-12">
  <div class="flex-col grow gap-4">
    @for (message of messages(); track $index) {
      <span class="body-2">{{message}}</span>
    }
  </div>
  <vl-big-button
    [iconRight]="buttonIcon()"
    [text]="buttonText()"
    (action)="onAction()"/>
</div>
